<div class="content">
  <div class="inner-content">
    <ng-content></ng-content>
  </div>
</div>
<div *ngIf="showCopyright"
     class="copyright">
  &copy; 2007 - {{ currentDate | date:'yyyy' }} Pipelinersales Inc.
</div>
